import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { BasicSectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'
import { OFFER_URL } from 'Constants/Values'

import Gallery from './Gallery'

function AccessSection() {
  const router = useRouter()

  const handleHeaderButtonClick = useCallback(() => {
    router.push(OFFER_URL)
  }, [router])

  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column fullWidth gap={10} maxWidth={LANDING_CONTENT_WIDTH_PX} pt={64}>
          <BasicSectionTitle
            buttonCaption="Explore Our Membership"
            plainText="That’s why we play at the best."
            subtitle="You deserve quality experiences with great people and in great venues right across Australia."
            title="access"
            onClick={handleHeaderButtonClick}
          />

          <Gallery />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default AccessSection
